/**
 * 公用方法文件
 */
import Vue from "vue";
/**
 * 存本地数据
 * @param item 名字
 * @param str 数据
 * @param type 本地数据类型,没有  sessionStorage 有 localStorage
 */
export const piUtSaveStorage = (item, str, type) => {
    const typeData = type || 0;
    if (typeof str == "object") {
        str = JSON.stringify(str);
    }
    const win = window;
    if (typeData) {
        win.localStorage.removeItem(item);
        win.localStorage[item] = str;
    }
    else {
        win.sessionStorage.removeItem(item);
        win.sessionStorage[item] = str;
    }
};
/**
 * 取本地数据
 * @param item 名字
 * @param type 本地数据类型,没有  sessionStorage 有  localStorage
 */
export const piUtGetStorage = (item, type) => {
    let value;
    const typeData = type || 0;
    const win = window;
    if (typeData) {
        if (win.localStorage[item] !== undefined) {
            value = win.localStorage[item];
            if (value.indexOf("{") == 0 || value.indexOf("[") == 0) {
                return JSON.parse(value);
            }
            else {
                return value;
            }
        }
        else {
            return false;
        }
    }
    else {
        if (win.sessionStorage[item] !== undefined) {
            value = win.sessionStorage[item];
            if (value.indexOf("{") == 0 || value.indexOf("[") == 0) {
                return JSON.parse(value);
            }
            else {
                return value;
            }
        }
        else {
            return false;
        }
    }
};
/**
 * 删除本地数据
 * @param name 名字
 * @param type 本地数据类型,没有 sessionStorage  有  localStorage
 */
export const piUtRemoveStorage = (name, type) => {
    const typeData = type || 0;
    const item = name || "-1";
    const win = window;
    if (typeData) {
        if (item == "-1") {
            win.localStorage.clear();
        }
        else {
            win.localStorage.removeItem(item);
        }
    }
    else {
        if (item == "-1") {
            win.sessionStorage.clear();
        }
        else {
            win.sessionStorage.removeItem(item);
        }
    }
};
/**
 * 去抖动
 */
export const piUtDebounce = (func, timeout) => {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func(...args);
        }, timeout);
    };
};
/**
 * 复制文本
 * @param text 复制内容
 */
export const piUtCopyText = (text) => {
    const win = window;
    if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        //区分iPhone设备
        const data = {};
        data.span = document.createElement("span");
        data.span.innerHTML = text;
        //span.style.display='none';
        data.span.id = "copyTextSpan";
        document.body.appendChild(data.span);
        win.getSelection().removeAllRanges(); //这段代码必须放在前面否则无效
        const range = document.createRange();
        // 选中需要复制的节点
        range.selectNode(data.span);
        // 执行选中元素
        win.getSelection().addRange(range);
        // 执行 copy 操作
        document.execCommand("copy");
        // 移除选中的元素
        win.getSelection().removeAllRanges();
        data.span["parentNode"].removeChild(data.span);
        Vue.prototype.$Message.success("复制成功");
    }
    else {
        const data = {};
        data.oInput = document.createElement("textarea");
        data.oInput.value = text;
        document.body.appendChild(data.oInput);
        data.oInput.select(); // 选择对象
        document.execCommand("Copy"); // 执行浏览器复制命令
        data.oInput.className = "oInput";
        data.oInput.style.display = "none";
        data.oInput.parentNode.removeChild(data.oInput);
        Vue.prototype.$Message.success("复制成功");
    }
};
